module.exports = __webpack_public_path__ + "img/513.28ec3e69.png";